import { UploadedDocumentDocumentType, VendorModel } from '@urbanx/agx.campaigns.client';
import { useSelectedCampaign } from './useSelectedCampaign';

export const useSelectedCampaignVendors = () => {
  const { selectedCampaign } = useSelectedCampaign();

  const vendors: VendorModel[] =
    selectedCampaign?.vendors?.map((vendor) => ({
      ...vendor,
      legalName: vendor.legalName ?? undefined,
      powerOfAttorney: !vendor.powerOfAttorney
        ? undefined
        : {
            ...vendor.powerOfAttorney,
            documentation: !vendor.powerOfAttorney.documentation
              ? undefined
              : {
                  ...vendor.powerOfAttorney.documentation,
                  documentType: vendor.powerOfAttorney.documentation
                    .documentType as unknown as UploadedDocumentDocumentType,
                },
          },
    })) ?? [];

  return vendors;
};
